<div
  class="sidenav sidenav-lg"
  [ngClass]="collapsed ? 'sidenav-collapsed' : ''">
  <div class="logo-container">
    <div class="logo-text" *ngIf="collapsed">
      <ng-container *ngIf="userInfo$ | async as userInfo">
        <img
          *ngIf="userInfo && userInfo.logo"
          [src]="userInfo.logo"
          alt="logo"
          class="logo" />
      </ng-container>
    </div>
    <button class="close-btn shadow-none" (click)="toggleCollapse()">
      <svg width="30" viewBox="0 0 24 24">
        <path
          fill="none"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3"
          d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
  </div>
  <div class="scrollwrap scrollwrap_delayed">
    <ul class="sidenav-nav">
      <li class="sidenav-nav-item" *ngFor="let data of navData">
        <ng-container *ngIf="data.hasAccess">
          <a
            class="sidenav-nav-link"
            [attr.aria-hidden]="true"
            *ngIf="data.items && data.items.length > 0"
            (click)="handleClick(data)"
            [ngClass]="getActiveClass(data)">
            <img [src]="data.icon" alt="nav-icon" />
            <span class="sidenav-link-text" *ngIf="collapsed">
              {{ data.label }}
            </span>
            <svg
              *ngIf="data.items && collapsed"
              class="menu-collapse-icon"
              [ngClass]="{ 'angle-down': data.expanded }"
              role="img"
              width="1em"
              height="1em"
              viewBox="0 0 24 24">
              <path
                fill="none"
                stroke="#f3f3f3"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2.5"
                d="m9 6l6 6l-6 6"></path>
            </svg>
          </a>
          <a
            class="sidenav-nav-link"
            *ngIf="!data.items || (data.items && data.items.length === 0)"
            [routerLink]="[data.routeLink]"
            [ngClass]="getActiveClass(data)">
            <img [src]="data.icon" alt="nav-icon" />
            <span class="sidenav-link-text" *ngIf="collapsed">
              {{ data.label }}
            </span>
          </a>
          <div *ngIf="collapsed && data.items && data.items.length > 0">
            <app-sublevel-menu
              [data]="data"
              [collapsed]="collapsed"
              [multiple]="multiple"
              [expanded]="data.expanded">
            </app-sublevel-menu>
          </div>
        </ng-container>
      </li>
    </ul>
  </div>
  <p *ngIf="collapsed" class="text-center text-white">Powered by Ubicomms</p>
</div>
